module.exports = __webpack_public_path__ + "static/img/product_banner_25_zh.59da90a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_25_zh.png
// module id = bMkP
// module chunks = 34